import enabledModules from '../../../enabled-modules.json';

export default {
    enabled: enabledModules.ar
}